export { default as SystemSubmodulesPage } from './page'


// WEBPACK FOOTER //
// ./src/pages/systemSubModules/index.js